export { default as NGradientText, gradientTextProps } from './src/GradientText';
